const basic = {
  a: 5,
  d: 100,
  s: 100,
  r: 600,
  h: 10,
};

const pad = {
  a: 800,
  d: 1500,
  s: 1,
  r: 1000,
  h: 30,
};

const pluck = {
  a: 2,
  d: 500,
  s: 200,
  r: 2,
  h: 10,
};

const stab = {
  a: 0,
  d: 20,
  s: 0,
  r: 0,
  h: 0,
};

const gliss = {
  a: 300,
  d: 1000,
  s: 0,
  r: 600,
  h: 10,
};

export default {
  basic,
  pad,
  pluck,
  stab,
  gliss,
};
